import React from "react"


export const RadioItem = ({item, index}) => {
    const [checked,setChecked] = React.useState(false)

    return (
        <li>
            <label htmlFor={'r'+index}>
            {/**  <input type="radio" name="workstyle" id={`r${i}`} /> **/}
                <div className="sb-checkbox">
                    <input type="radio" onClick={()=>setChecked(!checked)} className="sb-checkbox__input" id={'r'+index} name="category" />
                    <label className="sb-checkbox__label sb-checkbox__label--green" htmlFor={'r'+index} ></label>
                </div>
                
                <div className="title" >{item.title}</div>
            </label>
        </li>
    )
}
